<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" style="height:100%;" v-loading="loading" :element-loading-text="loadingText">
    <el-tabs class="zj-plan-resource-sett no-active-bar" height="100%" v-model="activeName">
      <el-tab-pane
        :key="item.name"
        v-for="(item) in EmergencyTaskSubType"
        :label="item.value"
        :name="item.code"
        :disabled="form.id && activeName != item.code ? true : false"
      >
        <ComponentRescueteamsDetail
          v-if="item.code=='1'"
          :ref="item.code"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.code"
          @loading="showLoading"
          @loadingFinish="hideLoading"
          :form="form"
        />
        <ComponentsupplieDetail
          v-if="item.code=='2'"
          :ref="item.code"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.code"
          @loading="showLoading"
          @loadingFinish="hideLoading"
          :form="form"
        />
        <ComponentshelterDetail
          v-if="item.code=='3'"
          :ref="item.code"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.code"
          @loading="showLoading"
          @loadingFinish="hideLoading"
          :form="form"
        />
        <ComponentCommunicationDetail
          v-if="item.code=='4'"
          :ref="item.code"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.code"
          @loading="showLoading"
          @loadingFinish="hideLoading"
          :form="form"
        />
        <ComponentMedicalDetail
          v-if="item.code=='5'"
          :ref="item.code"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.code"
          @loading="showLoading"
          @loadingFinish="hideLoading"
          :form="form"
        />
        <ComponentTransportDetail
          v-if="item.code=='6'"
          :ref="item.code"
          :PlanTaskId="PlanTaskId"
          :TaskSubTypeId="item.code"
          @loading="showLoading"
          @loadingFinish="hideLoading"
          :form="form"
        />
      </el-tab-pane>
    </el-tabs>
  </el-form>
</template>
<script>
import ComponentRescueteamsDetail from "./ComponentRescueteamsDetail";
import ComponentsupplieDetail from "./ComponentsupplieDetail";
import ComponentshelterDetail from "./ComponentshelterDetail";
import ComponentCommunicationDetail from "./ComponentCommunicationDetail";
import ComponentMedicalDetail from "./ComponentMedicalDetail";
import ComponentTransportDetail from "./ComponentTransportDetail";

import { getDictionary } from "@/api/src/emergency_common";
export default {
  name: "ZjResourcesSettingInfo",
  controller: "UI",
  action: "ResourcesSettingInfo",
  components: {
    ComponentRescueteamsDetail,
    ComponentsupplieDetail,
    ComponentshelterDetail,
    ComponentCommunicationDetail,
    ComponentMedicalDetail,
    ComponentTransportDetail
  },
  props: {
    PlanTaskId: { type: String },
    form:{ type: Object }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      activeName: "",
      EmergencyTaskSubType: [],
      ruleForm: {
        PlanTaskId: this.$props.PlanTaskId
      }
    };
  },
  created: function() {
    this.loadingRef = 0;
    this.showLoading('加载中...');
    getDictionary('emergency_task_resource_type')
      .then(d => {
        var data = d.data.records;
        if (data) {
          this.activeName = data[0].code;
          this.EmergencyTaskSubType = data;
          this.hideLoading();
        }
      })
      .catch(e => {
        console.error(e);
        this.hideLoading();
      });
  },
  methods: {
    showLoading(text) {
      this.loadingRef++;
      this.loading = true;
      this.loadingText = typeof(text) !== 'undefined' && text !== null ? text : '加载中...'
    },
    hideLoading() {
      this.loadingRef--;
      if (this.loadingRef == 0) {
        this.loading = false;
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
  watch:{
    'form.resouceList':{
      handler(val, oldVal) {
        if (val && val.length) {
          this.activeName = val[0].resourceType
        }
      },
      deep: true,
      immediate: true,
    }
  }
};
</script>
<style>
.zj-plan-resource-sett .el-tabs__header {
  border: none;
}
.zj-plan-resource-sett .is-active {
  background: url(/img/tabselected.png) no-repeat !important;
  background-size: 100% 100% !important;
  background-position: center !important;
}
.zj-plan-resource-sett .el-tabs__active-bar {
  display: none;
}
.zj-plan-resource-sett .el-tabs__item {
  width: 16rem;
  text-align: -webkit-center;
}
.zj-plan-resource-sett .el-tabs__item {
  background: url(/img/tab.png) no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
</style>